export default __webpack_public_path__ + "static/media/ic_open_in_new_48px.b18e8799.svg";